import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModalModule } from 'src/app/modal/modal.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoadingSpaceDeleteComponent } from './components/loading-space-element/loading-space-delete/loading-space-delete.component';
import { LoadingSpaceEditComponent } from './components/loading-space-element/loading-space-edit/loading-space-edit.component';
import { LoadingSpaceElementComponent } from './components/loading-space-element/loading-space-element.component';
import { LoadsListElementEditComponent } from './components/loads-list-element/components/loads-list-element-edit/loads-list-element-edit.component';
import { LoadsListElementComponent } from './components/loads-list-element/loads-list-element.component';
import { LoadsListComponent } from './loads-list.component';
import { StackingComponent } from './components/loads-list-element/components/loads-list-element-edit/components/stacking/stacking.component';
import { AddLoadingSpaceModule } from '../add-loading-space/add-loading-space.module';
import { MoreButtonComponent } from './components/more-button/more-button.component';
import { LoadsListPalletLayerGroupComponent } from './components/loads-list-pallet-layer-group/loads-list-pallet-layer-group.component';
import { LoadsListPalletLayerGroupEditComponent } from './components/loads-list-pallet-layer-group-edit/loads-list-pallet-layer-group-edit.component';
import { AddLoadModule } from '../add-load/add-load.module';

@NgModule({
    declarations: [
        LoadsListComponent,
        LoadsListPalletLayerGroupComponent,
        LoadsListPalletLayerGroupEditComponent,
        LoadsListElementComponent,
        LoadsListElementEditComponent,
        LoadingSpaceEditComponent,
        LoadingSpaceElementComponent,
        LoadingSpaceDeleteComponent,
        StackingComponent,
        MoreButtonComponent,
    ],
    imports: [CommonModule, SharedModule, DragDropModule, ModalModule, AddLoadingSpaceModule, AddLoadModule],
    exports: [LoadsListComponent]
})
export class LoadsListModule {}
